<p class="messageInfo">
  {{parcoursUtilisateur(subSection)}}
</p>
<div *ngFor="let field of subSection.fields; let i = index">
  <app-form-input [prefixId]="prefixId" [parentForm]="formGroup" [subSectionId]="subSection.id" [field]="field"
    [repeatablePath]="repeatablePath" [getRepeatablePathWithIndexForInput]="getRepeatablePathWithIndexForInput"
    [noticeValue]="noticeValue" [groupOrSectionId]="subSection.id" (newField)="newField($event)"
    [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
    (deleteField)="deleteField($event)" [index]="indexSubSection()"></app-form-input>
</div>
<div *ngIf="!isDuplicableElement()">
  <div *ngFor="let group of subSection.groups; let i = index">
    <app-accordion [elementId]="group.id" [prefixId]="prefixId" [isDeletable]="group.deletable"
      [elementLabel]="group._label" [isRepeatable]="group._repeatable" [infoBulle]="group.infoBulle"
      [groupType]="getGroupType(group.id)"
      (addSomething)="newGroup(group)" (deleteSomething)="deleteGroup(group)">
      <app-group [hidden]="group?.hidden" *ngIf="!group?.hidden" [prefixId]="prefixId" [formGroup]="formGroup"
        [group]="group" [subSectionId]="subSection.id" (newGroup)="newGroup($event)" (deleteGroup)="deleteGroup($event)"
        [repeatablePath]="repeatablePath" [getRepeatablePathWithIndexForGroup]="getRepeatablePathWithIndexForGroup"
        [indexGrp]="((indexGrp != ''||isInteger(indexGrp))? indexGrp+'_'+getIncr(group.id): '')"
        [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement" [noticeValue]="noticeValue"
        [parentsChild]="subSection.groups" [index]="indexSubSection()" [linkForRouter]="linkForRouter"
        (preferenceSelected)="chargeDonneePreference($event)">
      </app-group>
    </app-accordion>
  </div>
</div>

<div *ngIf="isDuplicableElement()">
  <div *ngFor="let item of counterArray; let i = index; trackBy: trackByDuplicableId">
    <app-duplicable-element [actualIndex]="item.index"
      [duplicableElement]=subSection.groups[0] [isDeletable]="isDuplicableElementDeletable()" [prefixId]="prefixId"
      [type]="subSection.groups[0]._idScheme"
      (addSomething)="newDuplicableElement(subSection.groups[0])"
      (deleteSomething)="deleteDuplicableElement(subSection.groups[0], item.index)"
      (loadDuplicableElement)="loadDuplicableElement($event)">
      <app-group *ngIf="displayGroup(item.index)" [prefixId]="prefixId" [formGroup]="formGroup" [group]="groupDuplicable"
        [subSectionId]="subSection.id" (newGroup)="newGroup($event)" (deleteGroup)="deleteGroup($event)"
        [repeatablePath]="repeatablePath" [getRepeatablePathForDuplicableElementFromParent]="getRepeatablePathForDuplicableElement"
        [indexGrp]="((indexGrp != ''||isInteger(indexGrp))? indexGrp+'_'+getIncr(subSection.groups[0].id): '')"
        [getRepeatablePathWithIndexForGroup]="getRepeatablePathWithIndexForGroup" [noticeValue]="noticeValue"
        [parentsChild]="subSection.groups" [index]="indexSubSection()" [linkForRouter]="linkForRouter"
        (preferenceSelected)="chargeDonneePreference($event)">
      </app-group>
    </app-duplicable-element>
  </div>
</div>
